// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4b15326c","455":"55aa9cf4"}[chunkId] + ".chunk.js";
};